import React from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import * as Icons from '@material-ui/icons';
import {
  Grid,
  withStyles,
  FormControlLabel,
  Checkbox,
  TableRow,
  TableCell,
  IconButton,
  Collapse,
} from '@material-ui/core';
import MultiSelect from '../../../components/Select/MultiSelect';

class ContentRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleSelectGroup = (e, tenantId) => {
    const { value, name, checked } = e.target;
    let { tenants, selected } = this.props.tenant.toJS();
    const tenant = tenants.data.find((t) => t.id === +tenantId);
    if (tenant) {
      if (name === 'selectAll') {
        if (checked) {
          selected = selected.filter((s) => s.tenantId !== tenant.id);
          selected.push({
            tenantId: tenant.id,
            groups: tenant.groups,
            checked: true,
          });
        } else {
          selected.forEach((s) => {
            if (s.tenantId === tenant.id) {
              s.groups = [];
            }
          });
        }
      } else {
        if (checked) {
          const group = (tenant.groups || []).filter((g) => g.id === +value);
          selected.forEach((s) => {
            if (s.tenantId === tenant.id) {
              s.groups = s.groups.concat(group);
            }
          });
        } else {
          selected.forEach((s) => {
            if (s.tenantId === tenant.id) {
              s.groups = s.groups.filter((g) => g.id !== +value);
            }
          });
        }
      }
    }
    this.props.tenant.setData('selected', selected, false);
  };

  handleSelectModules = (modules, groupId) => {
    let { selected } = this.props.tenant.toJS();
    selected.forEach((s) => {
      s.groups.forEach((g) => {
        if (g.id === groupId) {
          g.subGroups = modules;
        }
      });
    });
    // const selectedModules = modules.filter(m => m.tenantId === data.tenantId);
    // selected.forEach(s => {
    //   if (s.tenantId === data.tenantId && s.groups.length > 0) {
    //     s.groups.forEach(g => {
    //       if (g.id === groupId) {
    //         g.subGroups = selectedModules;
    //       }
    //     })
    //   }
    // });

    this.props.tenant.setData('selected', selected, false);
  };

  render() {
    const { t, row } = this.props;
    const { selected } = this.props.tenant.toJS();
    const selectData = (selected || []).find((s) => s.tenantId === row.id);
    const isCheckedAllGroups =
      selectData && selectData.checked && selectData.groups.length === row.groups.length ? true : false;
    const allOptions = { label: `${t('all_modules')}`, value: '*' };
    const isDisabledCheckedGroup = selectData && selectData.checked === false ? true : this.props.disabled;
    // console.log('selected: ', selected);
    return (
      <>
        <TableRow key={row.id}>
          <TableCell component='th' scope='row'>
            <Grid container alignItems='center'>
              <FormControlLabel
                aria-label='group'
                onClick={(event) => event.stopPropagation()}
                onFocus={(event) => event.stopPropagation()}
                control={
                  <Checkbox
                    name='tenantId'
                    id={`tenant-${row.name}`}
                    onChange={this.props.handleChangeTenant}
                    color='primary'
                    value={`${row.id}`}
                    disabled={this.props.disabled}
                    checked={selectData && selectData.tenantId === row.id ? true : false}
                  />
                }
                label={row.name}
              />
            </Grid>
          </TableCell>
          <TableCell align='right'>
            <IconButton
              aria-label='expand row'
              size='small'
              onClick={() => this.props.handleToggle(row.id)}
              disabled={this.props.disabled}
            >
              {row.toggle ? <Icons.ExpandLess /> : <Icons.ExpandMore />}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow style={{ display: row.toggle ? 'table-row' : 'none' }}>
          <TableCell colSpan={12} style={{ padding: '4px 40px' }}>
            <Collapse
              in={row.toggle}
              timeout='auto'
              unmountOnExit
              style={{ backgroundColor: '#E6F4F3', padding: '4px 30px' }}
            >
              {row.groups && row.groups.length > 0 && (
                <Grid container>
                  <FormControlLabel
                    aria-label='selectAll'
                    onClick={(event) => event.stopPropagation()}
                    onFocus={(event) => event.stopPropagation()}
                    control={
                      <Checkbox
                        name='selectAll'
                        id='selectAll'
                        onChange={(e) => this.handleSelectGroup(e, row.id)}
                        color='primary'
                        checked={isCheckedAllGroups}
                        disabled={selectData ? isDisabledCheckedGroup : true}
                      />
                    }
                    label={t('all_groups')}
                  />
                </Grid>
              )}
              {row.groups.map((g) => {
                const isCheckedGroups = selectData && selectData.checked && selectData.groups ? selectData.groups : [];
                const subgroupDatas = (isCheckedGroups || []).find((val) => val.id === g.id);
                const subGroups =
                  (subgroupDatas && subgroupDatas.subGroups.length) === g.subGroups.length
                    ? [allOptions, ...g.subGroups]
                    : subgroupDatas && subgroupDatas.subGroups;

                return (
                  <Grid container key={g.id}>
                    <Grid container item sm={4}>
                      <FormControlLabel
                        aria-label='group'
                        onClick={(event) => event.stopPropagation()}
                        onFocus={(event) => event.stopPropagation()}
                        control={
                          <Checkbox
                            name='group'
                            id='group'
                            onChange={(e) => this.handleSelectGroup(e, row.id)}
                            color='primary'
                            value={`${g.id}`}
                            checked={(isCheckedGroups || []).find((val) => val.id === g.id) ? true : false}
                            disabled={selectData ? isDisabledCheckedGroup : true}
                          />
                        }
                        label={g.name}
                      />
                    </Grid>
                    <Grid container item sm={8} key={g.id}>
                      <MultiSelect
                        id={g.id}
                        options={g.subGroups}
                        allOption={allOptions}
                        defaultSelectAll={true}
                        handleSelectModules={this.handleSelectModules}
                        valueData={subGroups ? subGroups : []}
                        disabled={this.props.disabled}
                      />
                    </Grid>
                  </Grid>
                );
              })}
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  }
}

const styles = (theme) => ({
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    width: '120px',
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
  btnExpand: {
    width: '150px',
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
  formControl: {
    width: '100%',
  },
  selectOption: {
    '& fieldset': {
      top: '-2px',
      bottom: '2px',
    },
    '& svg': {
      top: 'calc(50% - 8px)',
    },
    '& select': {
      paddingTop: '17px',
      paddingBottom: '5px',
    },
    '&:hover, &:focus': {
      borderColor: `${theme.palette.primary.main} !important`,
    },
  },
});
export const page = inject('device', 'tenant')(observer(ContentRow));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
